export default class FormHeader {

    constructor($view) {

        this.$view = $view;
        this.$activities =  this.$view.find(' .content .form .form-group .dropdown .form-check input');
        this.bind();

    }

    bind() {

        var button = $('.content .form .form-group .dropdown button');



        button[0].innerHTML = "Cochez la/les activité(s)";

        this.$activities.change(function(e){

            if(button[0].innerHTML === "Cochez la/les activité(s)")
            {
                button[0].innerHTML = '';
            }

            if( e.target.checked){
          //    button[0].innerHTML += ' ';
              button[0].innerHTML += e.target.value + " ";
            }else
            {
              var newStr =  button[0].innerHTML.replace(e.target.value + " ", '');
              button[0].innerHTML =newStr;
            }

            if(button[0].innerHTML === "")
            {
                button[0].innerHTML = "Cochez la/les activité(s)";
            }

        });


        // on ajout un event sur le code postal
        $("#code-postal-agency").keyup(function (e){
           var resultInput =e.target.value;
            $.ajax( {
                url: "/cities/search",
                data: {
                    autocomplete: resultInput,
                    format: 2,
                    name :'city-agency',
                    id:'ville-agency'
                },
                success: function(data) {
                    $("#ville-container").html(data.html);
                    $("#ville-agency").select2();
                },
                error: function(){

                },
            });
        });


    }

}